import React from "react";
import { LoginWrapper } from "shared";
import "./PrivacyPolicyPage.scss";

type PrivacyPolicyPageProps = {};

const PrivacyPolicyPage: React.FC<PrivacyPolicyPageProps> = () => {
  return (
    <LoginWrapper className="privacy-page">
      <>
        <p className="login-wrapper__subtitle">
          <div className="rodo-container">
            <h1 className="login-wrapper__header">POLITYKA PRYWATNOŚCI</h1>
            <ol className="numeric indentation--big">
              <li>
                Ochrona danych osobowych Użytkowników naszej Aplikacji jest
                sprawą najwyższej wagi. Dokładamy wszelkich starań, aby
                Użytkownicy czuli się bezpiecznie, powierzając swoje dane
                osobowe w trakcie korzystania z Aplikacji.
              </li>
              <li>
                Użytkownik to osoba fizyczna, osoba prawna albo jednostka
                organizacyjna, nieposiadająca osobowości prawnej, której ustawa
                przyznaje zdolność prawną, korzystająca z usług elektronicznych,
                dostępnych w ramach Aplikacji.
              </li>
              <li>
                Niniejsza polityka prywatności wyjaśnia zasady i zakres
                przetwarzania danych osobowych Użytkownika, przysługujące mu
                prawa, jak też obowiązki administratora tych danych, a także
                informuje o używaniu plików cookies.
              </li>
              <li>
                Administrator stosuje najnowocześniejsze środki techniczne i
                rozwiązania organizacyjne, zapewniające wysoki poziom ochrony
                przetwarzanych danych osobowych oraz zabezpieczenia przed
                dostępem osób nieupoważnionych.
              </li>
            </ol>
            <h3>I. Administrator Danych Osobowych</h3>
            <p>
              Administratorem danych osobowych jest spółka Reliance Holding sp.
              z o.o. z siedzibą przy al. 29 Listopada 39E/U3, 31-425 Kraków,
              wpisana w Rejestrze Przedsiębiorców prowadzonym przez Sąd Rejonowy
              dla Krakowa - Śródmieścia, XI Wydział Gospodarczy Krajowego
              Rejestru Sądowego pod numerem KRS: 0000686682, NIP: 6751598679,
              REGON: 36780485000000, kapitał zakładowy: 600 000,00 złotych
              (zwana dalej: „Administratorem"). Inspektorem ochrony danych jest
              Zuzanna Przybyła, adres e-mail: biuro@reliance.pro (zwany dalej:
              „IOD").
            </p>
            <h3>II. CEL PRZETWARZANIA DANYCH OSOBOWYCH</h3>
            <ol className="numeric indentation--big">
              <li>Administrator przetwarza dane osobowe Użytkownika w celu:</li>
              <li>Oznacza to, że dane te są potrzebne w szczególności do</li>
              <ul>
                <li>wystawienia faktury;</li>
                <li>dokonania rozliczeń;</li>
                <li>wykonania usług;</li>
                <li>
                  korzystania przez Użytkownika z wszelkich uprawnień
                  konsumenckich (np. odstąpienie od umowy, rękojmia).
                </li>
              </ul>
              <li>
                Użytkownik może również wyrazić zgodę na otrzymywanie informacji
                o nowościach i promocjach, co spowoduje, że administrator będzie
                również przetwarzać dane osobowe, w celu przesyłania
                Użytkownikowi informacji handlowych, dotyczących m.in. nowych
                produktów lub usług czy promocji.
              </li>
              <li>
                Dane osobowe są również przetwarzane w ramach wypełnienia
                prawnych obowiązków, ciążących na administratorze danych oraz
                realizacji zadań, w interesie publicznym m. in. do wykonywania
                zadań, związanych z bezpieczeństwem i obronnością lub
                przechowywaniem dokumentacji podatkowej.
              </li>
              <li>
                Dane osobowe mogą być również przetwarzane w celach marketingu
                bezpośredniego produktów, zabezpieczenia i dochodzenia roszczeń
                lub ochrony przed roszczeniami Użytkownika lub osoby trzeciej,
                jak również marketingu usług i produktów podmiotów trzecich lub
                marketingu własnego, niebędącego marketingiem bezpośrednim.
              </li>
              <li>
                Podanie danych osobowych jest dobrowolne, jednakże brak zgody na
                przetwarzanie danych osobowych uniemożliwia rejestrację Konta
                indywidualnego i korzystanie z Aplikacji.
              </li>
              <li>
                Możemy używać także danych osobowych w celu tworzenia profili
                preferencji naszych Użytkowników i tym samym w oparciu o nie,
                dostosowywać nasze usługi i treści jakie od nas otrzymują. W ten
                sposób możemy zdecydować, które z naszych usług mogą być dla
                Państwa odpowiednie.
              </li>
            </ol>
            <h3>III. RODZAJ DANYCH</h3>
            <ol className="numeric indentation--big">
              <li>
                Administrator przetwarza następujące dane osobowe, których
                podanie jest niezbędne do:
              </li>
              <ul>
                <li>założenia konta i korzystania z aplikacji:</li>
                <ul>
                  <li>imię i nazwisko;</li>
                  <li>numer telefonu;</li>
                </ul>
                <li>dane podawane przez Użytkownika opcjonalnie:</li>
                <ul>
                  <li>nazwa firmy oraz NIP (w przypadku faktury na firmę);</li>
                  <li>adres e-mail;</li>
                  <li>adres;</li>
                  <li>kod pocztowy;</li>
                  <li>miasto;</li>
                  <li>kraj;</li>
                </ul>
              </ul>
              <li>
                W przypadku odstąpienia od umowy bądź uznania reklamacji, gdy
                zwrot należności następuje bezpośrednio na rachunek bankowy
                Użytkownika, w celu dokonania zwrotu należności przetwarzamy
                również informacje, dotyczące numeru rachunku bankowego.
              </li>
            </ol>
            <h3>IV. PODSTAWA PRAWNA PRZETWARZANIA DANYCH OSOBOWYCH</h3>
            <ol className="numeric indentation--big">
              <li>
                Dane osobowe są przetwarzane zgodnie z przepisami Rozporządzenia
                Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia
                2016 r. w sprawie ochrony osób fizycznych w związku z
                przetwarzaniem danych osobowych i w sprawie swobodnego przepływu
                takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne
                rozporządzenie o ochronie danych), OJ L 119, 4.5.2016, p. 1–88,
                dalej zwane: „rozporządzenie RODO".
              </li>
              <li>
                Administrator przetwarza dane osobowe wyłącznie po uprzednim
                uzyskaniu zgody Użytkownika.
              </li>
              <li>
                Wyrażenie zgody na przetwarzanie danych osobowych jest
                całkowicie dobrowolne, jednakże brak jej udzielenia uniemożliwia
                korzystanie z aplikacji.
              </li>
            </ol>
            <h3>V. PRAWA PRZYSŁUGUJĄCE UŻYTKOWNIKOWI</h3>
            <ol className="numeric indentation--big">
              <li>
                Użytkownik w pewnych sytuacjach posiada prawo zgłoszenia żądania
                Administratorowi przeglądania, poprawiania, zmiany,
                ograniczenia, sprostowania lub usunięcia jego danych osobowych,
                którymi Administrator administruje oraz prawo do wniesienia
                sprzeciwu wobec przetwarzania jego danych osobowych przez
                Administratora. W tym celu należy wysłać wiadomość na adres
                e-mailowy:{" "}
                <a href="mailto:biuro@reliance.pro">biuro@reliance.pro</a>
              </li>
              <li>
                Zwracamy uwagę, iż nie zawsze będziemy w stanie wypełnić Państwa
                żądanie dotyczące usunięcia Państwa danych osobowych, a
                mianowicie ze względu na poszczególne obowiązki prawne lub
                dochodzenie roszczeń. W takich przypadkach zostanie to Państwu
                zakomunikowane po złożeniu takiego żądania. Jeśli pragną Państwo
                uzyskać więcej informacji na temat poszczególnych praw
                przedstawionych w ramach niniejszego paragrafu, prosimy o
                kontakt na adres e-mailowy: biuro@reliance.pro.
              </li>
              <li>
                Użytkownik ma prawo, w dowolnym momencie, wycofać zgodę na
                przetwarzanie danych osobowych, przesyłając w tym celu wiadomość
                na adres e-mailowy biuro@reliance.pro. Wycofanie zgody nie
                wpływa na zgodność z prawem przetwarzania, którego dokonano na
                podstawie zgody przed jej wycofaniem. Oznacza to, że odwołanie
                zgody dotyczy przyszłości, nie zaś przetwarzania danych, które
                miało miejsce w przeszłości, w okresie między udzieleniem a
                wycofaniem zgody.
              </li>
              <li>
                Użytkownik ma prawo zgłoszenia Administratorowi żądania
                przesłania jego danych osobowych, którymi Administrator
                administruje, innemu administratorowi danych osobowych, o ile
                wymagania techniczne oraz organizacyjne pozwalają na przesłanie
                takich danych osobowych.
              </li>
              <li>
                Administrator bez zbędnej zwłoki – a w każdym razie w terminie
                miesiąca od otrzymania żądania – udziela Użytkownikowi, który
                zgłosił jedno z żądań wymienione w niniejszym paragrafie,
                informacje o działaniach podjętych w związku z żądaniem, lub o
                ewentualnym przedłużeniu terminu z uwagi na charakter żądania
                lub liczbę żądań, lub o powodach niepodjęcia działań oraz o
                możliwości wniesienia skargi do organu nadzorczego i
                skorzystania ze środków ochrony prawnej przed sądem.
              </li>
              <li>
                Korzystanie z praw przedstawionych powyżej jest bezpłatne,
                jednakże Administrator może obciążyć Użytkownika rozsądną opłatą
                w przypadku, gdy przedstawione żądanie lub żądania są oczywiście
                bezzasadne, powtarzające się, bądź nadmierne. W takich
                przypadkach możemy również odmówić spełnienia przedstawionego
                żądania.
              </li>
              <li>
                W celu spełnienia poszczególnych żądań, Administrator może
                zażądać określonych informacji od Użytkownika, w celu
                weryfikacji jego tożsamości i zapewnienia korzystania z
                poszczególnych praw. Stanowi to środek bezpieczeństwa w celu
                zapewnienia, że dane osobowe nie zostaną ujawnione osobom
                nieuprawnionym.
              </li>
              <li>
                Użytkownik, którego danymi osobowymi Administrator administruje,
                ma prawo do wniesienia skargi do organu nadzorczego, w
                szczególności w państwie członkowskim:
              </li>
              <ul>
                <li>swojego zwykłego pobytu,</li>
                <li>swojego miejsca pracy, lub</li>
                <li>miejsca popełnienia domniemanego naruszenia,</li>
                jeśli uważa, że przetwarzanie danych osobowych go dotyczących
                narusza RODO. Skarga może zostać nadana drogą pocztową na adres
                Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00 – 193
                Warszawa lub za pośrednictwem poczty elektronicznej na adres
                <a href="mailto:kancelaria@uodo.gov.pl.">
                  kancelaria@uodo.gov.pl.
                </a>
              </ul>
            </ol>
            <h3>VI. OKRES PRZECHOWYWANIA DANYCH OSOBOWYCH</h3>
            <ol className="numeric indentation--big">
              <li>
                Zasadniczo dane osobowe są przechowywane tylko tak długo, jak to
                jest konieczne do wypełnienia zobowiązań umownych lub
                ustawowych, dla których zostały one zgromadzone. Dane te zostaną
                usunięte natychmiast, gdy ich przechowywanie nie będzie
                konieczne, w celach dowodowych, zgodnie z prawem cywilnym lub w
                związku z ustawowym obowiązkiem przechowywania danych.
              </li>
              <li>
                Informacje, dotyczące umowy, przechowuje się w celach
                dowodowych, przez okres trzech lat, począwszy od końca roku, w
                którym zakończono relacje handlowe z Użytkownikiem. Usunięcie
                danych nastąpi po upływie ustawowego terminu przedawnienia
                dochodzenia roszczeń umownych.
              </li>
              <li>
                Ponadto, Administrator może zachować informacje archiwalne,
                dotyczące zawartych transakcji, gdyż ich przechowywanie jest
                związane z przysługującymi Użytkownikowi roszczeniami np. z
                tytułu rękojmi.
              </li>
              <li>
                Jeśli żadna umowa nie została zawarta, między Użytkownikiem i
                Właścicielem, dane osobowe Użytkownika są przechowywane do czasu
                usunięcia konta Użytkownika w aplikacji. Usunięcie konta może
                nastąpić w wyniku wysunięcia żądania przez Użytkownika,
                wycofania zgody na przetwarzanie danych osobowych, bądź też
                zgłoszenia sprzeciwu co do przetwarzania tych danych.
              </li>
            </ol>
            <h3>VII. POWIERZENIE PRZETWARZANIA DANYCH INNYM PODMIOTOM</h3>
            <ol className="numeric indentation--big">
              <li>
                Administrator może powierzać przetwarzanie danych osobowych
                podmiotom współpracującym z Administratorem, w zakresie
                niezbędnym dla realizacji transakcji np. w celu przetworzenia
                płatności, obsługi technicznej Aplikacji lub przekazywania
                informacji handlowych, pochodzących od Administratora (ostatnie
                dotyczy Użytkowników, którzy wyrazili zgodę na otrzymywanie
                informacji handlowych).
              </li>
              <li>
                Poza celami, wskazanymi w niniejszej Polityce Prywatności, dane
                osobowe Użytkowników, nie będą w żaden sposób udostępniane
                osobom trzecim, ani przekazywane innym podmiotom, w celu
                przesyłania materiałów marketingowych tych osób trzecich.
              </li>
              <li>
                Dane osobowe Użytkowników Aplikacji nie są przekazywane poza
                obszar Unii Europejskiej.
              </li>
              <li>
                Niniejsza Polityka Prywatności jest zgodna z przepisami
                wynikającymi z art. 13 ust. 1 i ust. 2 rozporządzenia RODO.
              </li>
            </ol>
            <h3>VIII. PLIKI COOKIES</h3>
            <ol className="numeric indentation--big">
              <li>
                Aplikacja używa plików cookies (ciasteczka) lub podobnych
                technologii (dalej łącznie nazywane: "cookies") do zbierania
                informacji o dostępie Użytkownika do aplikacji (np. za pomocą
                komputera lub smartfonu) oraz jego preferencjach. Są one
                wykorzystywane m.in. w celach reklamowych i statystycznych oraz
                w celu dostosowania aplikacji do indywidualnych potrzeb
                Użytkownika.
              </li>
              <li>
                Pliki cookies to fragmenty informacji, które zawierają unikalny
                kod referencyjny, który aplikacja przesyła na urządzenie
                Użytkownika, w celu przechowywania, a czasem śledzenia
                informacji, dotyczących używanego urządzenia. Zwykle nie
                pozwalają one zidentyfikować osoby Użytkownika. Ich głównym
                zadaniem jest lepsze dopasowanie aplikacji do Użytkownika.
              </li>

              <li>
                Niektóre z plików cookies, występujące w aplikacji, są dostępne
                tylko przez czas trwania danej sesji internetowej i wygasają po
                zamknięciu przeglądarki. Inne pliki cookies służą do
                zapamiętywania Użytkownika, który po powrocie do aplikacji, jest
                na niej rozpoznawany. Są one wówczas zachowywane przed dłuższy
                czas.
              </li>
              <li>
                Podział plików cookies ze względu na niezbędność ich stosowania
                do poprawnego funkcjonowania Aplikacji:
              </li>
              <li>Pliki cookies używane w niniejszej Aplikacji to:</li>
              <ul className="without">
                <li>
                  _ga – do rozróżniania użytkowników w celach statystycznych
                  (Google Analytics)
                </li>
                <li>
                  _ga_Q4Y6FVEYZP – do analizy sesji i zachowania użytkownika
                  (Google Analytics 4)
                </li>
                <li>_ga_ERT8NJ3EV3 – dodatkowe dane sesji dla GA4</li>
                <li>
                  _fbp – do prowadzenia działań marketingowych i
                  remarketingowych (Facebook Pixel)
                </li>
                <li>
                  __stripe_mid – do rozpoznania użytkownika w systemie płatności
                  Stripe
                </li>
                <li>__stripe_sid – sesyjne ID płatności Stripe</li>
                <li>
                  wt_consent – przechowuje informacje o zgodach użytkownika na
                  cookies
                </li>
                <li>
                  sbjs_migrations – do analizy źródeł wizyt (Sourcebuster.js)
                </li>
                <li>sbjs_current – obecne źródło ruchu użytkownika</li>
                <li>sbjs_current_add – dodatkowe dane o obecnej wizycie</li>
                <li>sbjs_first – źródło pierwszej wizyty użytkownika</li>
                <li>sbjs_first_add – dodatkowe dane o pierwszej wizycie</li>
                <li>
                  sbjs_udata – dane użytkownika (np. user-agent) do śledzenia
                  ruchu
                </li>
              </ul>

              <li>
                Wszystkie pliki cookies, występujące w Aplikacji, są ustalane
                przez Administratora.
              </li>
              <li>
                Wszystkie pliki cookies, używane przez niniejszą Aplikację, są
                zgodne z obowiązującym prawem Unii Europejskiej.
              </li>
            </ol>
            <h3>CZY PLIKI COOKIES MOGĄ ZOSTAĆ WYŁĄCZONE?</h3>
            <p>
              Jak wyżej wspomniano <u>niezbędne</u> pliki cookies są konieczne
              do poprawnego funkcjonowania Aplikacji, w tym do przepływu
              informacji przez sieć teleinformatyczną lub do świadczenia usług
              na żądanie Użytkownika. Niezbędne pliki cookies ustawiane są
              automatycznie, a ich stosowanie nie wymaga zgody Użytkownika.
              Jeśli jednak nie życzą sobie Państwo instalowania tego typu plików
              cookies na Urządzeniu końcowym, można zmienić ustawienia
              przeglądarki tak, aby blokowała wszystkie pliki cookies, jednak
              Aplikacja nie będzie działała wtedy prawidłowo.
            </p>
            <p>
              Z kolei Pliki cookies, które <u>nie są niezbędne</u> do
              prawidłowego funkcjonowania naszej Aplikacji (w tym pliki
              funkcjonalne, analityczne i marketingowe) są wykorzystywane przez
              naszą Aplikację wyłącznie po uzyskaniu zgody Użytkownika.
              Użytkownik może zarządzać zgodami na wykorzystywanie plików
              Cookies, które <u>nie są niezbędne</u> do prawidłowego
              funkcjonowania naszej Strony, za pośrednictwem ustawień
              prywatności Aplikacji lub przeglądarki internetowej. W
              szczególności Użytkownik w każdym czasie może wycofać udzieloną
              wcześniej zgodę na korzystanie z plików cookies które{" "}
              <u>nie są niezbędne</u> do prawidłowego funkcjonowania naszej
              Strony.
            </p>
            <p>
              Standardowo przeglądarki internetowe dopuszczają przechowywanie
              plików Cookies. Ograniczenia czy wyłączenia stosowania plików
              cookies Użytkownik może dokonać poprzez stosowne zmiany w
              ustawieniach przeglądarki internetowej. Ustawienia te Użytkownik
              może zmienić w szczególności w taki sposób, aby blokować
              automatyczną obsługę plików cookies bądź informować o ich
              każdorazowym zamieszczeniu w Urządzeniu końcowym Użytkownika. W
              ten sposób również zgoda wyrażona na korzystanie z plików Cookies
              może w każdym momencie zostać zmodyfikowana lub odwołana.
              Szczegółowe informacje dotyczące sposobów obsługi plików cookies
              są dostępne w ustawieniach przeglądarek internetowych.
            </p>
            <p>
              Zwracamy uwagę, że ograniczenie stosowania plików cookies może
              spowodować brak dostępności do niektórych treści Aplikacji,
              korzystanie z Aplikacji może być dla Użytkownika mniej efektywne,
              utrudnione może być również korzystanie z usług.
            </p>
          </div>
        </p>
      </>
    </LoginWrapper>
  );
};

export default PrivacyPolicyPage;
